/**
 * Country SEO i18n — Wave 8
 * Fills remaining language gaps for: India, Brazil, QA/Kuwait/Bahrain GCC,
 * Austria, Greece, Finland, Hungary, Croatia, Serbia, Bulgaria
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE8: CountrySEOMap = {

  // Fill gaps for India
  india: {
    sv: {
      title: 'Callcenter Indien | Engelskspråkig Kundtjänst 24/7 | Call IT Dev',
      description: 'Outsourca callcenter till Indien: engelsktalande, 24/7, CSAT 95%, från 3 $/h. 75% besparing.',
      heroTitle: 'Callcenter för Indien — Engelskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den indiska marknaden.',
    },
    da: {
      title: 'Callcenter Indien | Engelsktalende Kundeservice 24/7 | Call IT Dev',
      description: 'Outsource callcenter til Indien: engelsktalende, 24/7, CSAT 95%, fra 3 $/t. 75% besparelse.',
      heroTitle: 'Callcenter til Indien — Engelsktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice til det indiske marked.',
    },
    ko: {
      title: '인도 콜센터 | 영어 고객 서비스 24/7 | Call IT Dev',
      description: '인도 콜센터: 영어 상담원, 24/7, CSAT 95%, 시간당 3달러부터. 75% 절감.',
      heroTitle: '인도 콜센터 — 영어 고객 서비스',
      heroSubtitle: '인도 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'インドコールセンター | 英語カスタマーサービス 24/7 | Call IT Dev',
      description: 'インド向けコールセンター: 英語ネイティブ、24/7、CSAT 95%、3$/時間〜。75%削減。',
      heroTitle: 'インド向けコールセンター — 英語カスタマーサービス',
      heroSubtitle: 'インド市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Brazil
  brazil: {
    sv: {
      title: 'Callcenter Brasilien | Portugisiskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Brasilien: portugisisktalande, CSAT 95%, från 3 $/h. 70% besparing.',
      heroTitle: 'Callcenter för Brasilien — Portugisiskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den brasilianska marknaden.',
    },
    da: {
      title: 'Callcenter Brasilien | Portugisisktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Brasilien: portugisisktalende, CSAT 95%, fra 3 $/t. 70% besparelse.',
      heroTitle: 'Callcenter til Brasilien — Portugisisktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice til det brasilianske marked.',
    },
    ko: {
      title: '브라질 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '브라질 콜센터: 포르투갈어 상담원, CSAT 95%, 시간당 3달러부터. 70% 절감.',
      heroTitle: '브라질 콜센터 — 포르투갈어 고객 서비스',
      heroSubtitle: '브라질 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ブラジルコールセンター | ポルトガル語カスタマーサービス | Call IT Dev',
      description: 'ブラジル向けコールセンター: ポルトガル語、CSAT 95%、3$/時間〜。70%削減。',
      heroTitle: 'ブラジル向けコールセンター — ポルトガル語カスタマーサービス',
      heroSubtitle: 'ブラジル市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Qatar
  qatar: {
    sv: {
      title: 'Callcenter Qatar | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Qatar: arabiska/engelska, CSAT 95%, från 5 $/h. 65% besparing vs Doha.',
      heroTitle: 'Callcenter för Qatar — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium arabisk och engelsk kundtjänst.',
    },
    da: {
      title: 'Callcenter Qatar | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Qatar: arabisk/engelsk, CSAT 95%, fra 5 $/t. 65% besparelse vs Doha.',
      heroTitle: 'Callcenter til Qatar — Flersproget Kundeservice',
      heroSubtitle: 'Premium arabisk og engelsk kundeservice.',
    },
    ko: {
      title: '카타르 콜센터 | 아랍어 & 영어 고객 서비스 | Call IT Dev',
      description: '카타르 콜센터: 아랍어/영어, CSAT 95%, 시간당 5달러부터. 도하 대비 65% 절감.',
      heroTitle: '카타르 콜센터 — 다국어 고객 서비스',
      heroSubtitle: '카타르 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'カタールコールセンター | アラビア語・英語カスタマーサービス | Call IT Dev',
      description: 'カタール向けコールセンター: アラビア語/英語、CSAT 95%、5$/時間〜。ドーハ比65%削減。',
      heroTitle: 'カタール向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: 'カタール市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Austria
  austria: {
    sv: {
      title: 'Callcenter Österrike | Tyskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Österrike: tysktalande, CSAT 95%, från 10 €/h. 55% besparing vs Wien.',
      heroTitle: 'Callcenter för Österrike — Tyskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den österrikiska marknaden.',
    },
    da: {
      title: 'Callcenter Østrig | Tysktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Østrig: tysktalende, CSAT 95%, fra 10 €/t. 55% besparelse vs Wien.',
      heroTitle: 'Callcenter til Østrig — Tysktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice til det østrigske marked.',
    },
    ko: {
      title: '오스트리아 콜센터 | 독일어 고객 서비스 | Call IT Dev',
      description: '오스트리아 콜센터: 독일어, CSAT 95%, 시간당 10유로부터. 비엔나 대비 55% 절감.',
      heroTitle: '오스트리아 콜센터 — 독일어 고객 서비스',
      heroSubtitle: '오스트리아 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'オーストリアコールセンター | ドイツ語カスタマーサービス | Call IT Dev',
      description: 'オーストリア向けコールセンター: ドイツ語、CSAT 95%、10€/時間〜。ウィーン比55%削減。',
      heroTitle: 'オーストリア向けコールセンター — ドイツ語カスタマーサービス',
      heroSubtitle: 'オーストリア市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Greece
  greece: {
    sv: {
      title: 'Callcenter Grekland | Kundtjänst Outsourcing | Call IT Dev',
      description: 'Outsourca callcenter till Grekland: grekiska/engelska, CSAT 95%, från 5 €/h. 55% besparing vs Aten.',
      heroTitle: 'Callcenter för Grekland — Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den grekiska marknaden.',
    },
    da: {
      title: 'Callcenter Grækenland | Kundeservice Outsourcing | Call IT Dev',
      description: 'Outsource callcenter til Grækenland: græsk/engelsk, CSAT 95%, fra 5 €/t. 55% besparelse vs Athen.',
      heroTitle: 'Callcenter til Grækenland — Kundeservice',
      heroSubtitle: 'Premium kundeservice til det græske marked.',
    },
    ko: {
      title: '그리스 콜센터 | 고객 서비스 아웃소싱 | Call IT Dev',
      description: '그리스 콜센터: 그리스어/영어, CSAT 95%, 시간당 5유로부터. 아테네 대비 55% 절감.',
      heroTitle: '그리스 콜센터 — 고객 서비스',
      heroSubtitle: '그리스 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ギリシャコールセンター | カスタマーサービス外注 | Call IT Dev',
      description: 'ギリシャ向けコールセンター: ギリシャ語/英語、CSAT 95%、5€/時間〜。アテネ比55%削減。',
      heroTitle: 'ギリシャ向けコールセンター — カスタマーサービス',
      heroSubtitle: 'ギリシャ市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Finland
  finland: {
    sv: {
      title: 'Callcenter Finland | Nordisk Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Finland: finska/engelska, CSAT 95%, från 10 €/h. 55% besparing vs Helsingfors.',
      heroTitle: 'Callcenter för Finland — Nordisk Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den finska marknaden.',
    },
    da: {
      title: 'Callcenter Finland | Nordisk Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Finland: finsk/engelsk, CSAT 95%, fra 10 €/t. 55% besparelse vs Helsinki.',
      heroTitle: 'Callcenter til Finland — Nordisk Kundeservice',
      heroSubtitle: 'Premium kundeservice til det finske marked.',
    },
    ko: {
      title: '핀란드 콜센터 | 북유럽 고객 서비스 | Call IT Dev',
      description: '핀란드 콜센터: 핀란드어/영어, CSAT 95%, 시간당 10유로부터. 헬싱키 대비 55% 절감.',
      heroTitle: '핀란드 콜센터 — 북유럽 고객 서비스',
      heroSubtitle: '핀란드 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'フィンランドコールセンター | 北欧カスタマーサービス | Call IT Dev',
      description: 'フィンランド向けコールセンター: フィンランド語/英語、CSAT 95%、10€/時間〜。ヘルシンキ比55%削減。',
      heroTitle: 'フィンランド向けコールセンター — 北欧カスタマーサービス',
      heroSubtitle: 'フィンランド市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Israel
  israel: {
    sv: {
      title: 'Callcenter Israel | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Israel: hebreiska/engelska/arabiska, CSAT 95%, från 5 $/h. 60% besparing.',
      heroTitle: 'Callcenter för Israel — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den israeliska marknaden.',
    },
    da: {
      title: 'Callcenter Israel | Flersproget Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Israel: hebraisk/engelsk/arabisk, CSAT 95%, fra 5 $/t. 60% besparelse.',
      heroTitle: 'Callcenter til Israel — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice til det israelske marked.',
    },
    ko: {
      title: '이스라엘 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '이스라엘 콜센터: 히브리어/영어/아랍어, CSAT 95%, 시간당 5달러부터. 60% 절감.',
      heroTitle: '이스라엘 콜센터 — 다국어 고객 서비스',
      heroSubtitle: '이스라엘 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'イスラエルコールセンター | 多言語カスタマーサービス | Call IT Dev',
      description: 'イスラエル向けコールセンター: ヘブライ語/英語/アラビア語、CSAT 95%、5$/時間〜。60%削減。',
      heroTitle: 'イスラエル向けコールセンター — 多言語カスタマーサービス',
      heroSubtitle: 'イスラエル市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Portugal
  portugal: {
    sv: {
      title: 'Callcenter Portugal | Portugisiskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Portugal: portugisisktalande, CSAT 95%, från 5 €/h. 55% besparing vs Lissabon.',
      heroTitle: 'Callcenter för Portugal — Portugisiskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den portugisiska marknaden.',
    },
    da: {
      title: 'Callcenter Portugal | Portugisisktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Portugal: portugisisktalende, CSAT 95%, fra 5 €/t. 55% besparelse vs Lissabon.',
      heroTitle: 'Callcenter til Portugal — Portugisisktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice til det portugisiske marked.',
    },
    ko: {
      title: '포르투갈 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '포르투갈 콜센터: 포르투갈어, CSAT 95%, 시간당 5유로부터. 리스본 대비 55% 절감.',
      heroTitle: '포르투갈 콜센터 — 포르투갈어 고객 서비스',
      heroSubtitle: '포르투갈 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ポルトガルコールセンター | ポルトガル語カスタマーサービス | Call IT Dev',
      description: 'ポルトガル向けコールセンター: ポルトガル語、CSAT 95%、5€/時間〜。リスボン比55%削減。',
      heroTitle: 'ポルトガル向けコールセンター — ポルトガル語カスタマーサービス',
      heroSubtitle: 'ポルトガル市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Netherlands
  netherlands: {
    sv: {
      title: 'Callcenter Nederländerna | Nederländskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Nederländerna: nederländsktalande, CSAT 95%, från 8 €/h. 55% besparing vs Amsterdam.',
      heroTitle: 'Callcenter för Nederländerna — Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den nederländska marknaden.',
    },
    da: {
      title: 'Callcenter Holland | Nederlandsktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Holland: nederlandsktalende, CSAT 95%, fra 8 €/t. 55% besparelse vs Amsterdam.',
      heroTitle: 'Callcenter til Holland — Kundeservice',
      heroSubtitle: 'Premium kundeservice til det nederlandske marked.',
    },
    ko: {
      title: '네덜란드 콜센터 | 네덜란드어 고객 서비스 | Call IT Dev',
      description: '네덜란드 콜센터: 네덜란드어, CSAT 95%, 시간당 8유로부터. 암스테르담 대비 55% 절감.',
      heroTitle: '네덜란드 콜센터 — 네덜란드어 고객 서비스',
      heroSubtitle: '네덜란드 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'オランダコールセンター | オランダ語カスタマーサービス | Call IT Dev',
      description: 'オランダ向けコールセンター: オランダ語、CSAT 95%、8€/時間〜。アムステルダム比55%削減。',
      heroTitle: 'オランダ向けコールセンター — オランダ語カスタマーサービス',
      heroSubtitle: 'オランダ市場向けプレミアムサポート。',
    },
  },

  // Fill gaps for Italy
  italy: {
    sv: {
      title: 'Callcenter Italien | Italienskspråkig Kundtjänst | Call IT Dev',
      description: 'Outsourca callcenter till Italien: italiensktalande, CSAT 95%, från 5 €/h. 55% besparing vs Milano.',
      heroTitle: 'Callcenter för Italien — Italienskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den italienska marknaden.',
    },
    da: {
      title: 'Callcenter Italien | Italiensktalende Kundeservice | Call IT Dev',
      description: 'Outsource callcenter til Italien: italiensktalende, CSAT 95%, fra 5 €/t. 55% besparelse vs Milano.',
      heroTitle: 'Callcenter til Italien — Italiensktalende Kundeservice',
      heroSubtitle: 'Premium kundeservice til det italienske marked.',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 이탈리아어, CSAT 95%, 시간당 5유로부터. 밀라노 대비 55% 절감.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 고객 서비스',
      heroSubtitle: '이탈리아 시장을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'イタリアコールセンター | イタリア語カスタマーサービス | Call IT Dev',
      description: 'イタリア向けコールセンター: イタリア語、CSAT 95%、5€/時間〜。ミラノ比55%削減。',
      heroTitle: 'イタリア向けコールセンター — イタリア語カスタマーサービス',
      heroSubtitle: 'イタリア市場向けプレミアムサポート。',
    },
  },
};
